<template>
  <v-dialog
    v-model   = "isDialogOpen"
    width     = "460px"
  >
    <v-card>
      <v-card-title>Import Clip List</v-card-title>
      <v-card-text class="pb-0">
        Import clips from {{ pathToImport }}?

        <v-checkbox 
          label   = "Clear existing clips before importing"
          v-model = "clearBeforeImport"
        >
        </v-checkbox>
      </v-card-text>
      <v-card-actions>

        <v-btn
          elevation   = "0"
          color       = "error"
          @click      = "isDialogOpen = false;"
        >
          Cancel
        </v-btn>

        <v-btn
          elevation   = "0"
          color       = "primary"
          @click      = "onImport"
        >
          Import Clips
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

// #region Imports

/* Telestream */
import { CLEAR_CLIPS, LOAD_CLIPS } from '@/utils/action-types';

// #endregion Imports

export default {

  // #region Properties

  data() {
    return {
      isDialogOpen:      false,
      pathToImport:      '',
      clearBeforeImport: false
    }
  },

  // #endregion Properties

  // #region Life-Cycle

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const cliplistPath = urlParams.get('cliplist');
    if (!cliplistPath) {
      return;
    }

    this.pathToImport = cliplistPath;
    this.isDialogOpen = true;
  },

  // #endregion Life-Cycle

  // #region Methods

  methods: {

    // #region Events

    onImport() {
      if (this.clearBeforeImport) {
        this.$store.dispatch(CLEAR_CLIPS);
      }

      this.$store.dispatch(LOAD_CLIPS, [this.pathToImport]);
      this.isDialogOpen = false;
    }

    // #endregion Events

  }

  // #endregion Methods

}

</script>

<style scoped lang="scss">

.v-card__actions {
  display:          flex;
  flex-direction:   row;

  .v-btn {
    flex:             1;
  }
}

</style>